export default __webpack_public_path__ + "static/media/blur-bg.1b7d57da.png";